import React from 'react';
import '../../App.css';
import './Tournaments.css';
import '../HeroSection.css';
import { Button } from '../Button';
import Footer from '../Footer';
import { useLang } from '../../i18n';
import NoticeModal from '../NoticeModal';
import U15Info from '../U15Info';

export default function U15() {
  const { t } = useLang();
  const [showNotice, setShowNotice] = React.useState(false);
  const handleButtonClick = (url, isDownload = false) => {
    if (isDownload) {
      const link = document.createElement('a');
      link.href = url;
      link.download = url.split('/').pop(); // Extracts the file name from the URL
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const newWindow = window.open(url, '_blank');
      if (newWindow) newWindow.focus();
    }
  };

  return (
    <React.Fragment>
      <div className='u15'>
        <div className='hero-container_tournament'>
          <h1>Slovak Youth U15</h1>
          <span className='label deadline'>{t('tournament.entryDeadline')} {t('tournament.upcoming')}</span>
          <p>{t('tournament.upcoming')}</p>

          <div className='tournaments-btns'>
            <Button 
              className='btns'
              buttonStyle='btn--outline'
              buttonSize='btn--large'
              onClick={() => handleButtonClick('/documents/SlovakYouthU15Invitation.pdf')}
            >
              {t('tournament.invitation')}
            </Button>

            {/* Registration temporarily closed — button disabled, explains on click */}
            <button
              className='btn btn--primary btn--large btn--disabled'
              aria-disabled='true'
              title={t('reg.notOpen')}
              onClick={() => setShowNotice(true)}
            >
              {t('tournament.register')}
            </button>

            <Button 
              className='btns'
              buttonStyle='btn--primary'
              buttonSize='btn--large'
              onClick={() => handleButtonClick('https://bwfbadminton.com/tournament/5553/slovak-youth-u17-international-2025/')}
            >
              {t('tournament.draws')}
            </Button>
          </div>

          {/* <div className='tournaments-info-wrapper'>
            <div className='tournaments-info'>
            ⓘ Provisional times can be changed subject to the number of entries. 
            </div>
            <div className='tournaments-info'>
            Singles will be played in groups in first stage, then by KO system,
            doubles will be played by KO system.
            In the event of any dispute, the Referee´s decision shall be final.
            </div>
          </div> */}
          
        </div>
      </div>
      {showNotice && <NoticeModal text={t('reg.notOpen')} onClose={() => setShowNotice(false)} />}
      <U15Info />
      <Footer />
    </React.Fragment>
  );
}